import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=2af69d5e&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"
import style0 from "./Goods.vue?vue&type=style&index=0&id=2af69d5e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af69d5e",
  null
  
)

export default component.exports